export default "__VITE_ASSET__BgTgLhCB__"